module.exports = __webpack_public_path__ + "img/sales-expenses.cc60ac6f.svg";